// import { confirmAlert } from "react-confirm-alert";

export const logApiFail = (path, request, response) => {
  // eslint-disable-next-line no-undef
  Rollbar.warning("API FAILURE: " + path, { request: request, response: response });
};
